<ng-select
  [items]="languages"
  bindValue="code"
  [(ngModel)]="currentLanguage"
  (change)="switchLanguage($event)"
  [clearable]="false"
  [searchable]="false"
>
  <!-- Opciones del dropdown -->
  <ng-template ng-option-tmp let-item="item">
    <div class="flags-row">
      <img [src]="item.flagUrl" class="flag-icon" alt="flag" />
    </div>
  </ng-template>

  <!-- Label seleccionado -->
  <ng-template ng-label-tmp let-item="item">
    <div class="flags-row">
      <img [src]="item.flagUrl ? item.flagUrl : currentUrl" class="flag-icon" alt="flag" />
    </div>
  </ng-template>
</ng-select>
